import React from 'react';
import { Delivery } from '@one-thd/sui-icons';
import PropTypes from 'prop-types';
import {
  Link
} from '@one-thd/sui-atomic-components';

export const DeliveryZipcodeButton = ({
  assortmentZipCode,
  onClick,
  showIcon = true,
  className = '',
  ...linkProps
}) => {
  if (!assortmentZipCode) {
    return null;
  }

  return (
    <div className={`sui-flex sui-items-center sui-gap-2 ${className}`}>
      {showIcon && <Delivery />}
      <Link
        data-testid="delivery-zipcode-button"
        component="button"
        onClick={onClick}
        underline="always"
        {...linkProps}
      >
        {assortmentZipCode}
      </Link>
    </div>
  );
};

DeliveryZipcodeButton.displayName = 'DeliveryZipcodeButton';

DeliveryZipcodeButton.propTypes = {
  assortmentZipCode: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  showIcon: PropTypes.bool,
  className: PropTypes.string
};

DeliveryZipcodeButton.defaultProps = {
  assortmentZipCode: '',
  showIcon: true,
  className: ''
};
